module.exports = __webpack_public_path__ + "static/media/home.89393166.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/vectors/home.svg
// module id = 511
// module chunks = 0